/** Index navigation must finish before referral URL decoration runs. */
export function isAdminIndexPath(pathname: string): boolean {
  return /^\/admin\/?$/.test(pathname);
}

export function buildAdminIndexRedirectTarget(
  search: string,
  isSupportUiEnabled: boolean
): string {
  const normalizedSearch = search.startsWith("?") ? search : search ? `?${search}` : "";
  const searchParameters = new URLSearchParams(normalizedSearch);
  return searchParameters.has("userId")
    ? `/admin/users${normalizedSearch}`
    : isSupportUiEnabled
      ? "/admin/support/threads"
      : "/admin/users";
}
